import React, { useState, useEffect } from 'react';
import axios from 'axios';
import colors from '../Constant/colors.js';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import LoadingButton from './LoadingButton.jsx';
import edwardianFont from "../assets/fonts/ITCEDSCR.ttf";
const ExamResultForm = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState('');
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState('');
  const [students, setStudents] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subjectMarks, setSubjectMarks] = useState({});
  const [coScholasticAreas, setCoScholasticAreas] = useState([]);
  const [coGrades, setCoGrades] = useState({});
  const [scores, setScores] = useState({});
  const [remarks, setRemarks] = useState({});

  // Nursery / LKG / UKG use Written + Oral + Assessment.
  // Foundation is hidden only for Nursery / LKG / UKG.
  // Class 1 onwards can use Foundation.
  const isNurseryLkgUkg = (value) => {
    const normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");

    return ["nursery", "nurs", "nur", "lkg", "ukg"].includes(normalized);
  };

  const [examResults, setExamResults] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingResultId, setEditingResultId] = useState('');
  const [viewingResult, setViewingResult] = useState(null);
  const [showReportCard, setShowReportCard] = useState(false);
  const currentSessionId = localStorage.getItem("currentSessionId");
  const [academicSession, setAcademicSession] = useState("");
  const [loading, setLoading] = useState(false);
  const labelStyle = "block text-black font-semibold text-[18px] mb-1";
  const inputBase = "w-full px-3 py-2 rounded-lg focus:outline-none placeholder:text-[14px] placeholder:text-gray-400 text-[14px] bg-white";
  const inputBorder = { border: `1px solid #1E40AF` };
  const button18 = { fontSize: "18px", padding: "12px 26px", borderRadius: "8px", fontWeight: "600", cursor: "pointer" };
  

    console.log(localStorage.getItem("currentSessionId"));
  // Fetch classes and exam results once session is loaded
  useEffect(() => {
    if (!currentSessionId) return;

    // Fetch the selected/current academic session from backend
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/session/getSessions`)
      .then((res) => {
        const sessionList = Array.isArray(res.data)
          ? res.data
          : res.data?.sessions || [];

        const currentSession =
          sessionList.find(
            (session) =>
              String(session?._id) === String(currentSessionId)
          ) ||
          sessionList.find(
            (session) =>
              session?.isCurrent === true ||
              session?.isCurrent === "true"
          );

        const sessionName =
          currentSession?.sessionName ||
          currentSession?.academicSession ||
          currentSession?.academicYear ||
          currentSession?.name ||
          currentSession?.title ||
          "";

        setAcademicSession(String(sessionName).trim());

        if (sessionName) {
          localStorage.setItem(
            "academicSession",
            String(sessionName).trim()
          );
        }
      })
      .catch((err) => {
        console.error("Academic session fetch error:", err);

        const localSession =
          localStorage.getItem("academicSession") ||
          localStorage.getItem("currentAcademicSession") ||
          "";

        setAcademicSession(localSession);
      });

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${currentSessionId}`, {
    }).then(res => setClasses(res.data));

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/getAllExamResults`, {
      params: { sessionId: currentSessionId }
    }).then(res => setExamResults(res.data));
  }, [currentSessionId]);

  // Fetch sections, exams, and subjects when class changes
useEffect(() => {
  if (!selectedClass || !currentSessionId) {
    setSections([]);
    setExams([]);
    setSubjects([]);
    setSubjectMarks({});
    return;
  }

  // Fetch sections
  axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`, {
    params: { sessionId: currentSessionId }
  })
  .then(res => {
    if(res.data.length === 0) {
      alert(`No sections available for class ${selectedClass}`);
    }
    setSections(res.data);
  })
  .catch(err => {
    console.error(err);
    alert(`Failed to fetch sections for class ${selectedClass}`);
    setSections([]);
  });

  // Fetch exams
  axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/exams/getExamByClass/${selectedClass}`, {
    params: { sessionId: currentSessionId }
  })
  .then(res => {
    if(res.data.length === 0) {
      alert(`No exams available for class ${selectedClass}`);
    }
    setExams(res.data);
  })
  .catch(err => {
    console.error(err);
    alert(`No exams found for class ${selectedClass}`);
    setExams([]);
  });

}, [selectedClass, currentSessionId]);


// Fetch students based on selected class and section
useEffect(() => {
  if (!selectedClass || !currentSessionId) {
    setStudents([]);
    return;
  }

  // Students EDIT mode vich vi fetch honge
  if (selectedSection) {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`,
        {
          params: {
            sessionId: currentSessionId,
            class: selectedClass,
            section: selectedSection,
            status: "active",
          },
        }
      )
      .then((res) => {
        const studentData = Array.isArray(res.data)
          ? res.data
          : res.data?.students || [];

        setStudents(studentData);
      })
      .catch((err) => {
        console.error(
          "Error fetching students:",
          err
        );

        setStudents([]);
      });
  }
}, [
  selectedClass,
  selectedSection,
  currentSessionId,
  isEditing,
]);


// Load subjects + Co-Scholastic Areas from the selected exam/date sheet.
// While editing an old result, merge newly-added date-sheet subjects with
// the old result subjects so existing marks are never removed.
useEffect(() => {
  if (!selectedExam || !exams.length) {
    setSubjects([]);
    setSubjectMarks({});
    setCoScholasticAreas([]);
    return;
  }

  const selectedExamData = exams.find(
    (exam) => exam.examName === selectedExam
  );

  if (!selectedExamData) {
    setSubjects([]);
    setSubjectMarks({});
    setCoScholasticAreas([]);
    return;
  }

  const dateSheetSubjects = Array.isArray(selectedExamData.subjects)
    ? selectedExamData.subjects
    : [];

  const resultBeingEdited = isEditing
    ? examResults.find((result) => String(result?._id) === String(editingResultId))
    : null;

  const oldResultSubjects = Array.isArray(resultBeingEdited?.subjects)
    ? resultBeingEdited.subjects
    : [];

  // Date-sheet subjects come first. Old result-only subjects are retained too,
  // so old data remains available even if a subject was later removed.
  const mergedSubjects = [...dateSheetSubjects];

  oldResultSubjects.forEach((oldSubject) => {
    const exists = mergedSubjects.some(
      (subject) =>
        String(subject?.subjectName || '').trim().toLowerCase() ===
        String(oldSubject?.subjectName || '').trim().toLowerCase()
    );

    if (!exists) {
      mergedSubjects.push(oldSubject);
    }
  });

  setSubjects(mergedSubjects);

  const marks = {};

  mergedSubjects.forEach((subject) => {
    const dateSheetMarks = Number(subject?.totalMarks);
    const oldSubject = oldResultSubjects.find(
      (item) =>
        String(item?.subjectName || '').trim().toLowerCase() ===
        String(subject?.subjectName || '').trim().toLowerCase()
    );

    const oldMarks = Number(oldSubject?.totalMarks);

    // Existing result subject: keep its old maximum marks/data exactly as saved.
    // Newly added date-sheet subject: use the date-sheet maximum marks.
    marks[subject.subjectName] =
      Number.isFinite(oldMarks) && oldResultSubjects.some(
        (item) =>
          String(item?.subjectName || '').trim().toLowerCase() ===
          String(subject?.subjectName || '').trim().toLowerCase()
      )
        ? oldMarks
        : Number.isFinite(dateSheetMarks)
          ? dateSheetMarks
          : subject?.totalMarks || 0;
  });

  setSubjectMarks(marks);

  const areas = Array.isArray(selectedExamData.coScholasticAreas)
    ? selectedExamData.coScholasticAreas
        .map((area) =>
          typeof area === 'string' ? area : area?.name
        )
        .map((name) => String(name || '').trim())
        .filter(Boolean)
    : [];

  // Keep unique areas only.
  const uniqueAreas = areas.filter(
    (area, index, arr) =>
      arr.findIndex(
        (item) => item.toLowerCase() === area.toLowerCase()
      ) === index
  );

  setCoScholasticAreas(uniqueAreas);
}, [selectedExam, exams, isEditing, editingResultId, examResults]);


const handleSAMarksChange = (studentId, subject, value) => {
  setScores(prev => ({
    ...prev,
    [studentId]: {
      ...prev[studentId],
      [subject]: {
        ...prev[studentId]?.[subject],
        sa: value,
      },
    },
  }));
};

const handleOralMarksChange = (studentId, subject, value) => {
  setScores(prev => ({
    ...prev,
    [studentId]: {
      ...prev[studentId],
      [subject]: {
        ...prev[studentId]?.[subject],
        oral: value,
      },
    },
  }));
};

const handleAssessmentChange = (studentId, subject, value) => {
  setScores(prev => ({
    ...prev,
    [studentId]: {
      ...prev[studentId],
      [subject]: {
        ...prev[studentId]?.[subject],
        assessment: value,
      },
    },
  }));
};

const handleSubjectMarksChange = (subject, value) => {
  setSubjectMarks(prev => ({
    ...prev,
    [subject]: value,
  }));
};

const handleRemarkChange = (studentId, value) => {
  setRemarks(prev => ({
    ...prev,
    [studentId]: value,
  }));
};

const handleCoGradeChange = (studentId, area, grade) => {
  setCoGrades((prev) => ({
    ...prev,
    [studentId]: {
      ...prev[studentId],
      [area]: grade,
    },
  }));
};

const getSubjectTotal = (studentId, subject) => {
  const writtenOrSa =
    parseFloat(scores[studentId]?.[subject]?.sa) || 0;

  const oral = isNurseryLkgUkg(selectedClass)
    ? parseFloat(scores[studentId]?.[subject]?.oral) || 0
    : 0;

  const assessment =
    parseFloat(scores[studentId]?.[subject]?.assessment) || 0;

  return writtenOrSa + oral + assessment;
};

const calculateTotal = studentId => {
  return Object.keys(subjectMarks).reduce((sum, subject) => {
    return sum + getSubjectTotal(studentId, subject);
  }, 0);
};

const calculatePercentage = studentId => {
  const total = calculateTotal(studentId);

  const maxTotal = Object.values(subjectMarks).reduce(
    (sum, m) => sum + (parseFloat(m) || 0),
    0
  );

  return maxTotal
    ? ((total / maxTotal) * 100).toFixed(2)
    : "0.00";
};

  const resetForm = () => {
    setSelectedClass('');
    setSelectedSection('');
    setSelectedExam('');
    setSubjects([]);
    setSubjectMarks({});
    setCoScholasticAreas([]);
    setCoGrades({});
    setStudents([]);
    setScores({});
    setRemarks({});
    setIsEditing(false);
    setEditingResultId('');
  };

 const handleSubmit = () => {
  setLoading(true);

  if (!selectedClass || !selectedSection || !selectedExam) {
    alert("Please select Class, Section, and Exam.");
    setLoading(false);
    return;
  }

  if (!students || students.length === 0) {
    alert("No students found for the selected Class and Section.");
    setLoading(false);
    return;
  }

  if (!subjects || subjects.length === 0) {
    alert("Please add at least one subject.");
    setLoading(false);
    return;
  }

  const data = {
    sessionId: currentSessionId,
    examName: selectedExam,
    className: selectedClass,
    sectionName: selectedSection,
    subjects: subjects.map(s => ({
      subjectName: s.subjectName,
      totalMarks:
        Number(subjectMarks[s.subjectName]) || 0,
    })),
    coScholasticAreas: coScholasticAreas.map((area) => ({
      name: area,
    })),
    students: students.map(st => ({
      studentId: st._id,
      rollNo: st.rollNo,
      studentName: `${st.firstName} ${st.lastName}`,
      scores: Object.keys(subjectMarks).map(sub => {
        const writtenOrSa =
          parseFloat(scores[st._id]?.[sub]?.sa) || 0;

        const oral = isNurseryLkgUkg(selectedClass)
          ? parseFloat(scores[st._id]?.[sub]?.oral) || 0
          : 0;

        const assessment =
          parseFloat(scores[st._id]?.[sub]?.assessment) || 0;

        return {
          subjectName: sub,
          sa: writtenOrSa,
          oral,
          assessment,
          score: writtenOrSa + oral + assessment,
        };
      }),
      coScholastic: coScholasticAreas.map((area) => ({
        area,
        grade: coGrades[st._id]?.[area] || "",
      })),
      remark: remarks[st._id] || "",
    })),
  };

  const req = isEditing && editingResultId
    ? axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/updateExamResult/${editingResultId}`, data)
    : axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/examresults/createExamResult`, data);

  req
    .then(() => {
      alert(isEditing ? "Result updated" : "Result added");
      resetForm();
    })
    .catch(() => {
      alert("Operation failed");
    })
    .finally(() => {
      setLoading(false);
    });
};


 const handleEdit = id => {
  const res = examResults.find(r => r._id === id);
  if (!res) return;

  setSelectedClass(res.className);
  setSelectedSection(res.sectionName);
  setSelectedExam(res.examName);

  setSubjects(res.subjects);

  const scoresMap = {};
  const remarksMap = {};
  res.students.forEach(st => {
    const studentId =
      st.studentId?._id ||
      st.studentId;

    scoresMap[studentId] = {};

    (st.scores || []).forEach(s => {
      scoresMap[studentId][s.subjectName] = {
        sa:
          s.sa ??
          s.saMarks ??
          0,

        oral:
          s.oral ??
          s.oralMarks ??
          0,

        assessment:
          s.assessment ??
          s.assessmentMarks ??
          0,
      };
    });

    remarksMap[studentId] =
      st.remark || '';
  });

  setScores(scoresMap);
  setRemarks(remarksMap);

  const subjMarks = {};
  res.subjects.forEach(s => {
    subjMarks[s.subjectName] = s.totalMarks;
  });
  setSubjectMarks(subjMarks);

  const resultAreas = Array.isArray(res.coScholasticAreas)
    ? res.coScholasticAreas
        .map((area) => typeof area === "string" ? area : area?.name)
        .map((name) => String(name || "").trim())
        .filter(Boolean)
    : [];

  const gradeMap = {};
  (res.students || []).forEach((student) => {
    const studentId = student.studentId?._id || student.studentId;
    gradeMap[studentId] = {};

    (student.coScholastic || []).forEach((item) => {
      const area = item?.area || item?.name || "";
      if (area) {
        gradeMap[studentId][area] = item?.grade || "";
      }
    });
  });

  setCoScholasticAreas(resultAreas);
  setCoGrades(gradeMap);

  setIsEditing(true);
  setEditingResultId(id);
};


  const handleDelete = id => {
    if (!window.confirm("Delete result?")) return;
    axios.delete(` ${process.env.REACT_APP_API_BASE_URL}/api/examresults/deleteExamResult/${id}`, {
      params: { sessionId: currentSessionId }
    }).then(() => setExamResults(prev => prev.filter(r => r._id !== id)));
  };

  // PDF generation function unchanged
const generatePDFReportCardForStudent = async (
  examResult,
  studentId
) => {
  const container = document.getElementById(
    "pdf-reportcard-container"
  );

  if (!container) {
    alert("PDF container not found!");
    return;
  }

  // =========================================================
  // BASIC DATA
  // =========================================================

  const allSubjects = Array.isArray(
    examResult?.subjects
  )
    ? examResult.subjects
    : [];

  const examStudents = Array.isArray(
    examResult?.students
  )
    ? examResult.students
    : [];

  const resultStudent =
    examStudents.find(
      (st) =>
        String(st?.studentId) ===
        String(studentId)
    );

  if (!resultStudent) {
    alert("Student not found!");
    return;
  }

  // =========================================================
  // HELPERS
  // =========================================================

  const escapeHtml = (value) => {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const safeValue = (
    value,
    fallback = "-"
  ) => {
    const text = String(
      value ?? ""
    ).trim();

    return text
      ? escapeHtml(text)
      : fallback;
  };

  const getNumber = (...values) => {
    for (const value of values) {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        Number.isFinite(Number(value))
      ) {
        return Number(value);
      }
    }

    return null;
  };

  // =========================================================
  // GRADE
  // =========================================================

  const getGrade = (percentageValue) => {
    const percentage = Number(
      percentageValue
    );

    if (!Number.isFinite(percentage)) {
      return "";
    }

    if (percentage >= 91) return "A1";
    if (percentage >= 81) return "A2";
    if (percentage >= 71) return "B1";
    if (percentage >= 61) return "B2";
    if (percentage >= 51) return "C1";
    if (percentage >= 41) return "C2";
    if (percentage >= 33) return "D";

    return "E";
  };

  // =========================================================
  // FIND ACTUAL STUDENT
  // =========================================================

  let actualStudent = null;

  if (
    Array.isArray(students) &&
    students.length > 0
  ) {
    actualStudent =
      students.find(
        (st) =>
          String(st?._id) ===
          String(studentId)
      ) ||
      students.find(
        (st) =>
          String(st?.studentId) ===
          String(studentId)
      );
  }

  // =========================================================
  // FETCH STUDENT IF NOT FOUND
  // =========================================================

  if (!actualStudent) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`,
        {
          params: {
            sessionId: currentSessionId,
            class:
              examResult?.className,
            section:
              examResult?.sectionName,
            status: "active",
          },
        }
      );

      const fetchedStudents =
        Array.isArray(response?.data)
          ? response.data
          : [];

      actualStudent =
        fetchedStudents.find(
          (st) =>
            String(st?._id) ===
            String(studentId)
        ) ||
        fetchedStudents.find(
          (st) =>
            String(st?.studentId) ===
            String(studentId)
        );
    } catch (error) {
      console.error(
        "Student fetch error:",
        error
      );
    }
  }

  // =========================================================
  // STUDENT NAME
  // =========================================================

  const studentName =
    [
      actualStudent?.firstName,
      actualStudent?.middleName,
      actualStudent?.lastName,
    ]
      .filter(Boolean)
      .join(" ") ||
    resultStudent?.studentName ||
    [
      resultStudent?.firstName,
      resultStudent?.middleName,
      resultStudent?.lastName,
    ]
      .filter(Boolean)
      .join(" ") ||
    "-";

  // =========================================================
  // FATHER NAME
  // =========================================================

  const fatherName =
    actualStudent?.fatherName ||
    actualStudent?.father_name ||
    actualStudent?.father ||
    actualStudent?.fatherFullName ||
    resultStudent?.fatherName ||
    resultStudent?.father_name ||
    resultStudent?.father ||
    "-";

 // =========================================================
// ADMISSION NUMBER
// =========================================================

const admissionNo =
  actualStudent?.admission_id ||
  resultStudent?.admission_id ||
  "-";

  // =========================================================
  // CLASS / SECTION
  // =========================================================

  const className =
    examResult?.className ||
    actualStudent?.class ||
    resultStudent?.className ||
    "-";

  const sectionName =
    examResult?.sectionName ||
    actualStudent?.section ||
    resultStudent?.sectionName ||
    "-";

  // =========================================================
  // EXAM NAME
  // =========================================================

  const examName =
    examResult?.examName ||
    examResult?.examTitle ||
    examResult?.examType ||
    examResult?.name ||
    "Exam";

  // =========================================================
  // ACADEMIC SESSION
  // Resolve the session again while generating the PDF so the
  // report card never depends on the React state finishing first.
  // =========================================================
  let reportAcademicSession =
    academicSession ||
    localStorage.getItem("academicSession") ||
    localStorage.getItem("currentAcademicSession") ||
    "";

  // If ExamResult already contains a populated session object, use it.
  const resultSession = examResult?.sessionId;
  if (!reportAcademicSession && resultSession && typeof resultSession === "object") {
    reportAcademicSession =
      resultSession?.sessionName ||
      resultSession?.academicSession ||
      resultSession?.academicYear ||
      resultSession?.name ||
      resultSession?.title ||
      "";
  }

  // IMPORTANT: /api/classes/getClasses returns the session populated like:
  // sessionId: { _id: "...", sessionName: "2024-25" }
  // So use the selected student's class/session data as a direct fallback.
  if (!reportAcademicSession && Array.isArray(classes)) {
    const classSession = classes.find((item) => {
      const itemClass = item?.className || item?.class || "";
      const itemSessionId =
        typeof item?.sessionId === "object"
          ? item?.sessionId?._id
          : item?.sessionId;

      return (
        String(itemClass).trim() === String(className).trim() &&
        (!currentSessionId ||
          !itemSessionId ||
          String(itemSessionId) === String(currentSessionId))
      );
    });

    if (classSession?.sessionId && typeof classSession.sessionId === "object") {
      reportAcademicSession =
        classSession.sessionId?.sessionName ||
        classSession.sessionId?.academicSession ||
        classSession.sessionId?.academicYear ||
        classSession.sessionId?.name ||
        "";
    }
  }

  // Final backend lookup by the exact session id.
  if (!reportAcademicSession) {
    try {
      const sessionResponse = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/session/getSessions`
      );

      const rawSessions = sessionResponse?.data;
      const sessionList = Array.isArray(rawSessions)
        ? rawSessions
        : Array.isArray(rawSessions?.sessions)
          ? rawSessions.sessions
          : Array.isArray(rawSessions?.data)
            ? rawSessions.data
            : [];

      const resultSessionId =
        typeof resultSession === "object"
          ? resultSession?._id
          : resultSession;

      const sessionToUse =
        sessionList.find(
          (session) =>
            String(session?._id || session?.id || "") ===
            String(resultSessionId || currentSessionId || "")
        ) ||
        sessionList.find(
          (session) =>
            session?.isCurrent === true ||
            session?.isCurrent === "true"
        );

      reportAcademicSession =
        sessionToUse?.sessionName ||
        sessionToUse?.academicSession ||
        sessionToUse?.academicYear ||
        sessionToUse?.name ||
        sessionToUse?.title ||
        sessionToUse?.year ||
        "";

      if (reportAcademicSession) {
        reportAcademicSession = String(reportAcademicSession).trim();
        setAcademicSession(reportAcademicSession);
        localStorage.setItem("academicSession", reportAcademicSession);
      }
    } catch (sessionError) {
      console.error("Report card academic session fetch error:", sessionError);
    }
  }

  // Last fallback: if the classes API has populated session data, use it.
  if (!reportAcademicSession && Array.isArray(classes)) {
    const fallbackClass = classes.find((item) =>
      String(item?.className || item?.class || "").trim() ===
      String(className).trim()
    );

    const fallbackSession = fallbackClass?.sessionId;
    reportAcademicSession =
      (typeof fallbackSession === "object" ? fallbackSession?.sessionName : "") ||
      "";
  }

  // =========================================================
  // STUDENT SCORES
  // SA + ASSESSMENT = TOTAL
  // =========================================================

  const scores = Array.isArray(
    resultStudent?.scores
  )
    ? resultStudent.scores
    : [];

  const findScore = (
    subjectName
  ) => {
    return (
      scores.find(
        (score) =>
          String(
            score?.subjectName || ""
          )
            .trim()
            .toLowerCase() ===
          String(
            subjectName || ""
          )
            .trim()
            .toLowerCase()
      ) || {}
    );
  };

  // =========================================================
  // REPORT CARD SUBJECTS
  // GK/Moralvalues is intentionally excluded.
  //
  // Foundation is shown ONLY for classes 4-10.
  // Nursery/LKG/UKG + classes 1-3 never show Foundation.
  // =========================================================

  const isEarlyYears =
    isNurseryLkgUkg(className);

  const foundationAllowed = !isNurseryLkgUkg(className);

  const reportCardSubjects =
    allSubjects.filter(
      (subject) =>
        !/^\s*gk\s*\/\s*moralvalues\s*$/i.test(
          String(
            subject?.subjectName || ""
          ).trim()
        )
    );

  // =========================================================
  // FOUNDATION SUBJECTS
  // ONLY CLASS 4 TO CLASS 10
  // =========================================================

  const foundationSubjects =
    foundationAllowed
      ? reportCardSubjects.filter(
          (subject) =>
            /\bfoundation\s*$/i.test(
              String(
                subject?.subjectName || ""
              ).trim()
            )
        )
      : [];

  // =========================================================
  // NORMAL SCHOLASTIC SUBJECTS
  // Foundation subjects are removed completely for:
  // Nursery, LKG, UKG, Class 1, Class 2, Class 3.
  // For Class 4-10, Foundation remains in its separate table.
  // =========================================================

  const scholasticSubjects =
    reportCardSubjects
      .filter(
        (subject) =>
          !/\bfoundation\s*$/i.test(
            String(
              subject?.subjectName ||
                ""
            ).trim()
          )
      )
      .slice(0, 8);

  // =========================================================
  // COMPONENT MAXIMUMS
  // Nursery/LKG/UKG:
  // Written + Oral + Assessment = Total
  //
  // If individual maximums are not stored, they are calculated
  // dynamically from subject totalMarks using 50% / 30% / 20%.
  // Example: 100 => 50 / 30 / 20
  // =========================================================

  const getComponentMaximums = (
    subject,
    totalMaximum
  ) => {
    const maximum =
      Number(totalMaximum) || 0;

    const explicitWritten = getNumber(
      subject?.writtenMarks,
      subject?.writtenMaxMarks,
      subject?.writtenMaximumMarks
    );

    const explicitOral = getNumber(
      subject?.oralMarks,
      subject?.oralMaxMarks,
      subject?.oralMaximumMarks
    );

    const explicitAssessment = getNumber(
      subject?.assessmentMarks,
      subject?.assessmentMaxMarks,
      subject?.assessmentMaximumMarks
    );

    if (
      explicitWritten !== null ||
      explicitOral !== null ||
      explicitAssessment !== null
    ) {
      const written =
        explicitWritten !== null
          ? explicitWritten
          : Math.max(
              0,
              maximum -
                (explicitOral || 0) -
                (explicitAssessment || 0)
            );

      const oral =
        explicitOral !== null
          ? explicitOral
          : Math.max(
              0,
              maximum -
                written -
                (explicitAssessment || 0)
            );

      const assessment =
        explicitAssessment !== null
          ? explicitAssessment
          : Math.max(
              0,
              maximum -
                written -
                oral
            );

      return {
        written,
        oral,
        assessment,
      };
    }

    const written =
      Math.round(maximum * 0.5);

    const oral =
      Math.round(maximum * 0.3);

    const assessment =
      Math.max(
        0,
        maximum - written - oral
      );

    return {
      written,
      oral,
      assessment,
    };
  };

  // =========================================================
  // SUBJECT DATA
  // Nursery/LKG/UKG:
  // Written + Oral + Assessment = Total
  //
  // Class 1-10:
  // SA + Assessment = Total
  // =========================================================

  const subjectData =
    scholasticSubjects.map(
      (subject) => {
        const subjectName =
          String(
            subject?.subjectName ||
              ""
          ).trim();

        const scoreItem =
          findScore(
            subjectName
          );

        const writtenMarks =
          getNumber(
            scoreItem?.written,
            scoreItem?.sa,
            scoreItem?.saMarks
          ) || 0;

        const oralMarks =
          isEarlyYears
            ? getNumber(
                scoreItem?.oral,
                scoreItem?.oralMarks
              ) || 0
            : 0;

        const assessmentMarks =
          getNumber(
            scoreItem?.assessment,
            scoreItem?.assessmentMarks
          ) || 0;

        const totalMarks =
          getNumber(
            scoreItem?.score,
            scoreItem?.total,
            scoreItem?.marks,
            scoreItem?.obtainedMarks
          );

        const total =
          isEarlyYears
            ? writtenMarks +
              oralMarks +
              assessmentMarks
            : totalMarks !== null
              ? totalMarks
              : writtenMarks +
                assessmentMarks;

        const maximumMarks =
          getNumber(
            subject?.totalMarks,
            subject?.maxMarks,
            subject?.maximumMarks
          ) || 0;

        const componentMaximums =
          isEarlyYears
            ? getComponentMaximums(
                subject,
                maximumMarks
              )
            : null;

        const percentage =
          maximumMarks > 0
            ? (total /
                maximumMarks) *
              100
            : 0;

        return {
          subjectName,

          sa: writtenMarks,

          written:
            writtenMarks,

          oral:
            oralMarks,

          assessment:
            assessmentMarks,

          total,

          maximum:
            maximumMarks,

          writtenMaximum:
            componentMaximums?.written ||
            0,

          oralMaximum:
            componentMaximums?.oral ||
            0,

          assessmentMaximum:
            componentMaximums?.assessment ||
            0,

          percentage,

          grade:
            getGrade(
              percentage
            ),
        };
      }
    );

  // =========================================================
  // REPORT CARD COLUMN MAXIMUMS
  // =========================================================

  const reportWrittenMaximum =
    subjectData.length > 0
      ? subjectData[0].writtenMaximum
      : 0;

  const reportOralMaximum =
    subjectData.length > 0
      ? subjectData[0].oralMaximum
      : 0;

  const reportAssessmentMaximum =
    subjectData.length > 0
      ? subjectData[0].assessmentMaximum
      : 0;

  // =========================================================
  // TOTALS
  // =========================================================

  const totalSA =
    subjectData.reduce(
      (sum, item) =>
        sum +
        (Number(item.sa) || 0),
      0
    );

  const totalOral =
    subjectData.reduce(
      (sum, item) =>
        sum +
        (Number(item.oral) || 0),
      0
    );

  const totalAssessment =
    subjectData.reduce(
      (sum, item) =>
        sum +
        (Number(item.assessment) || 0),
      0
    );

  const totalObtained =
    subjectData.reduce(
      (sum, item) =>
        sum +
        (Number(item.total) || 0),
      0
    );

  const totalMaximum =
    subjectData.reduce(
      (sum, item) =>
        sum +
        (Number(item.maximum) || 0),
      0
    );

  const overallPercentage =
    totalMaximum > 0
      ? (
          (totalObtained /
            totalMaximum) *
          100
        ).toFixed(2)
      : "0.00";

  const overallGrade =
    getGrade(
      overallPercentage
    );

  // =========================================================
  // SUBJECT SPACING
  // =========================================================

  let subjectPadding = "4px 5px";
  let subjectFontSize = "11px";
  let subjectLineHeight = "11px";
  let subjectRowHeight = "24px";

  if (
    subjectData.length >= 8
  ) {
    subjectPadding = "2px 3px";
    subjectFontSize = "9.5px";
    subjectLineHeight = "9px";
    subjectRowHeight = "18px";
  } else if (
    subjectData.length >= 6
  ) {
    subjectPadding = "2.5px 3px";
    subjectFontSize = "10px";
    subjectLineHeight = "9.5px";
    subjectRowHeight = "20px";
  } else if (
    subjectData.length >= 4
  ) {
    subjectPadding = "3px 4px";
    subjectFontSize = "10.5px";
    subjectLineHeight = "10px";
    subjectRowHeight = "22px";
  }

  // =========================================================
  // SUBJECT ROWS
  // =========================================================

  const subjectRows =
    subjectData
      .map(
        (item) => `
          <tr
            style="
              height:${subjectRowHeight};
            "
          >

            <td
              class="subject-cell"
              style="
                padding:${subjectPadding};
                font-size:${subjectFontSize};
                line-height:${subjectLineHeight};
              "
            >
              ${safeValue(
                item.subjectName
              )}
            </td>

            <td
              class="marks-cell"
              style="
                padding:${subjectPadding};
                font-size:${subjectFontSize};
                line-height:${subjectLineHeight};
              "
            >
              ${item.written}
            </td>

            ${
              isEarlyYears
                ? `
                  <td
                    class="marks-cell"
                    style="
                      padding:${subjectPadding};
                      font-size:${subjectFontSize};
                      line-height:${subjectLineHeight};
                    "
                  >
                    ${item.oral}
                  </td>
                `
                : ""
            }

            <td
              class="marks-cell assessment-cell"
              style="
                padding:${subjectPadding};
                font-size:${subjectFontSize};
                line-height:${subjectLineHeight};
              "
            >
              ${item.assessment}
            </td>

            <td
              class="marks-cell"
              style="
                padding:${subjectPadding};
                font-size:${subjectFontSize};
                line-height:${subjectLineHeight};
              "
            >
              ${item.total}
            </td>

            <td
              class="marks-cell grade-cell"
              style="
                padding:${subjectPadding};
                font-size:${subjectFontSize};
                line-height:${subjectLineHeight};
              "
            >
              ${
                item.grade || "-"
              }
            </td>

          </tr>
        `
      )
      .join("");

  // =========================================================
  // FOUNDATION DATA
  // =========================================================

  const foundationData =
    foundationSubjects.map(
      (subject) => {
        const subjectName =
          String(
            subject?.subjectName ||
              ""
          ).trim();

        const scoreItem =
          findScore(
            subjectName
          );

        const maximum =
          getNumber(
            subject?.totalMarks,
            subject?.maxMarks,
            subject?.maximumMarks
          ) || 0;

        const obtained =
          getNumber(
            scoreItem?.score,
            scoreItem?.marks,
            scoreItem?.obtainedMarks
          ) || 0;

        return {
          subjectName,
          maximum,
          obtained,
        };
      }
    );

  // =========================================================
  // FOUNDATION ROWS
  // =========================================================

  const foundationRows =
    foundationData.length > 0
      ? foundationData
          .map(
            (item) => `
              <tr>

                <td
                  class="foundation-name"
                >
                  ${safeValue(
                    item.subjectName
                  )}
                </td>

                <td
                  class="marks-cell"
                >
                  ${item.maximum}
                </td>

                <td
                  class="marks-cell"
                >
                  ${item.obtained}
                </td>

              </tr>
            `
          )
          .join("")
      : `
          <tr>
            <td
              colspan="3"
              class="no-data-cell"
            >
              No Foundation Subject
            </td>
          </tr>
        `;

  // =========================================================
  // DYNAMIC CO-SCHOLASTIC AREAS
  // =========================================================

  const configuredCoAreas = Array.isArray(examResult?.coScholasticAreas)
    ? examResult.coScholasticAreas
        .map((area) => typeof area === "string" ? area : area?.name)
        .map((name) => String(name || "").trim())
        .filter(Boolean)
    : [];

  const studentCoAreas = Array.isArray(resultStudent?.coScholastic)
    ? resultStudent.coScholastic
        .map((item) => item?.area || item?.name)
        .map((name) => String(name || "").trim())
        .filter(Boolean)
    : [];

  const coScholasticAreas = [
    ...configuredCoAreas,
    ...studentCoAreas,
  ].filter(
    (area, index, arr) =>
      arr.findIndex(
        (item) => item.toLowerCase() === area.toLowerCase()
      ) === index
  );

  const coSource =
    resultStudent?.coScholastic ||
    examResult?.coScholastic ||
    resultStudent?.coScholasticAreas ||
    examResult?.coScholasticAreas ||
    [];

  const coArray =
    Array.isArray(coSource)
      ? coSource
      : [];

  const findCoItem = (
    areaName
  ) => {
    return coArray.find(
      (item) => {
        const name =
          item?.area ||
          item?.name ||
          item?.subjectName ||
          item?.title ||
          "";

        return (
          String(name)
            .trim()
            .toLowerCase() ===
          String(areaName)
            .trim()
            .toLowerCase()
        );
      }
    );
  };

  const coScholasticRows =
    coScholasticAreas
      .map(
        (areaName) => {
          const item =
            findCoItem(
              areaName
            );

          const grade =
            item?.grade ||
            item?.gradeValue ||
            "";

          return `
            <tr>

              <td
                class="co-area"
              >
                ${safeValue(
                  areaName
                )}
              </td>

              <td
                class="co-grade"
              >
                ${
                  grade || "-"
                }
              </td>

            </tr>
          `;
        }
      )
      .join("");

  // =========================================================
  // SCHOOL LOGO
  // =========================================================

  const schoolLogo =
    "https://ik.imagekit.io/gqpk1bdvr/school_logo_GtaCcmp15.jpeg";

  // Principal signature supplied for the report card
  const principalSignature =
    "data:image/png;base64,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";

  // =========================================================
  // CLEAR CONTAINER
  // =========================================================

  container.innerHTML = "";

  // =========================================================
  // CREATE PDF CARD
  // =========================================================

  const card =
    document.createElement(
      "div"
    );

  card.style.width =
    "794px";

  card.style.minHeight =
    "1123px";

  card.style.background =
    "#ffffff";

  card.style.color =
    "#000000";

  card.style.fontFamily =
    "Arial, Helvetica, sans-serif";

  card.style.boxSizing =
    "border-box";

  card.style.padding =
    "10px";

  // =========================================================
  // CARD HTML
  // =========================================================

  card.innerHTML = `

    <style>

      @import url("https://fonts.googleapis.com/css2?family=Ballet&display=swap");

      * {
        box-sizing: border-box;
      }

      /* =====================================================
         MAIN REPORT CARD
         ===================================================== */

      .report-card {
  width: 100%;
  min-height: 1103px;

  border: 1.5px solid #333 !important;

  padding: 10px 12px 12px;

  background: #fff;
  color: #000;

  display: flex;
  flex-direction: column;

  overflow: hidden;
  box-sizing: border-box;
}

      /* =====================================================
         CLIENT REQUEST: CENTER ALL REPORT CARD CONTENT
         ===================================================== */

      .report-card,
      .report-card * {
        text-align: center !important;
      }


      /* =====================================================
         SCHOOL HEADER
         ===================================================== */

      .school-header {
        position: relative;

        min-height: 120px;

        padding: 5px 5px 6px;

        text-align: center;

        border-bottom: 1px solid #333;

        flex-shrink: 0;
      }

      .school-logo {
        position: absolute;

        left: 7px;

        top: 5px;

        width: 150px;

        height: 100px;

        object-fit: contain;
      }

      @font-face {
  font-family: "EdwardianScriptITC";
  src: url("${edwardianFont}") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.school-name {
   font-family: "EdwardianScriptITC", cursive !important;
        font-weight: bold !important;
        font-style: italic !important;
  font-size: 32px;
  font-weight: normal;
  font-style: normal;
  line-height: 38px;
  color: #172554;
  white-space: nowrap;
}

      .affiliation {
        font-size: 11px;

        font-weight: bold;

        color: #9a3412;

        line-height: 14px;

        margin-top: 2px;
      }

      .school-address {
        font-size: 12px;

        line-height: 15px;

        margin-top: 2px;
      }

      .school-contact {
        font-size: 9.5px;

        line-height: 12px;

        margin-top: 3px;
      }

      /* =====================================================
         SESSION
         ===================================================== */

     .session-report {
  width: calc(100% + 24px);
  margin-left: -12px;

  text-align: center;

  padding: 4px 12px 6px;

  border-bottom: 1px solid #333;

  flex-shrink: 0;

  box-sizing: border-box;
}

      .session-title {
        font-size: 11px;

        font-weight: bold;

        line-height: 13px;
      }

      .report-title {
        font-size: 12px;

        font-weight: bold;

        line-height: 14px;
      }

      /* =====================================================
         STUDENT INFO
         ===================================================== */

      .student-info {
        width: 100%;

        display: grid;

        grid-template-columns:
          1fr
          1fr;

        column-gap: 50px;

        row-gap: 2px;

        padding: 4px 24px 3px;

        flex-shrink: 0;
      }

      .student-detail {
        font-size: 9px;

        line-height: 12px;

        overflow-wrap: anywhere;
      }

      .student-label {
        font-weight: bold;
      }

      /* =====================================================
         SECTION TITLE
         ===================================================== */

      .section-title {
        font-size: 10px;

        font-weight: bold;

        line-height: 12px;

        padding: 3px 4px 3px;

        flex-shrink: 0;
      }

      /* =====================================================
         COMMON TABLE
         ===================================================== */

      table {
        width: 100%;

        border-collapse: collapse;

        border-spacing: 0;
      }

      tr {
        page-break-inside: avoid;

        break-inside: avoid;
      }

      /* =====================================================
         SCHOLASTIC TABLE
         ===================================================== */

      .marks-table {
        width: 100%;

        table-layout: fixed;

        margin-top: 3px;

        flex-shrink: 0;
      }

      .marks-table th {
        border: 1px solid #777;

        background: #eeeeee;

        text-align: center;

        vertical-align: middle;

        font-weight: bold;

        font-size: 7.5px;

        line-height: 9px;

        padding: 3px 2px;

        height: 19px;
      }

      .marks-table td {
        border: 1px solid #777;

        vertical-align: middle !important;

        overflow-wrap: anywhere;
      }

      .term-heading {
        font-size: 9px !important;

        line-height: 11px !important;

        height: 20px !important;

        padding: 3px !important;
      }

      .subject-cell {
        text-align: left;

        padding-left: 5px !important;

        white-space: normal;

        overflow-wrap: anywhere;

        word-break: normal;

        vertical-align: middle !important;
      }

      .marks-cell {
        text-align: center;

        vertical-align: middle !important;

        white-space: nowrap;
      }

      .assessment-cell {
        color: #333;
      }

      .grade-cell {
        font-weight: bold;
      }

      .total-row td {
  border: 1px solid #777;
  background: #eeeeee;
  font-weight: bold;

  height: 18px !important;

  padding: 2px 3px !important;

  font-size: 7.5px !important;

  line-height: 9px !important;

  vertical-align: middle !important;
}

      /* =====================================================
         OVERALL PERCENTAGE
         IMPORTANT:
         INSIDE TABLE - NO OVERLAP
         ===================================================== */

      .percentage-row td {
        border: 1px solid #777;

        border-top: none;

        text-align: right;

        font-size: 8px;

        font-weight: bold;

        line-height: 11px;

        height: 19px;

        padding: 3px 5px;

        vertical-align: middle !important;

        background: #fff;
      }

      /* =====================================================
         FOUNDATION
         ===================================================== */

      .small-table {
        width: 100%;

        table-layout: fixed;

        flex-shrink: 0;
      }

      .small-table th {
        border: 1px solid #777;

        background: #eeeeee;

        text-align: center;

        vertical-align: middle;

        font-size: 7.5px;

        line-height: 9px;

        padding: 3px;

        height: 19px;
      }

      .small-table td {
        border: 1px solid #777;

        vertical-align: middle !important;

        font-size: 8px;

        line-height: 10px;

        padding: 3px 4px;

        height: 20px;
      }

      .foundation-name {
        text-align: left !important;

        overflow-wrap: anywhere;

        vertical-align: middle !important;
      }

      .no-data-cell {
        text-align: center !important;

        height: 22px !important;

        padding: 4px !important;
      }

      /* =====================================================
         CO-SCHOLASTIC
         ===================================================== */

      .co-table th {
        height: 22px !important;

        padding: 4px 5px !important;

        font-size: 8px !important;

        line-height: 10px !important;

        vertical-align: middle !important;
      }

      .co-table td {
        height: 23px !important;

        padding: 4px 5px !important;

        font-size: 8.5px !important;

        line-height: 11px !important;

        vertical-align: middle !important;
      }

      .co-area {
        text-align: left !important;

        vertical-align: middle !important;

        overflow-wrap: anywhere;
      }

      .co-grade {
        text-align: center !important;

        font-weight: bold;

        vertical-align: middle !important;
      }

      /* =====================================================
         RESULT
         ===================================================== */

      .result-row {
        border: 1px solid #777;

        margin-top: 4px;

        padding: 4px 6px;

        min-height: 25px;

        font-size: 8.5px;

        line-height: 12px;

        flex-shrink: 0;
      }

      /* =====================================================
         REMARK
         ===================================================== */

      .remark-row {
        border: 1px solid #777;

        min-height: 31px;

        padding: 4px 6px;

        font-size: 8.5px;

        line-height: 12px;

        overflow-wrap: anywhere;

        flex-shrink: 0;
      }

      /* =====================================================
         GRADING TABLES
         ===================================================== */

      .grading-table {
        width: 100%;

        table-layout: fixed;

        border-collapse: collapse;

        flex-shrink: 0;
      }

      .grading-table th,
      .grading-table td {
        border: 1px solid #777;

        text-align: center;

        vertical-align: middle !important;

        font-size: 6.8px;

        line-height: 9px;

        padding: 3px 2px;

        height: 17px;

        white-space: nowrap;
      }

      .grading-table th {
        background: #eeeeee;

        font-weight: bold;
      }

      .grading-table tr:first-child th {
        height: 19px;

        padding: 3px 2px;

        line-height: 10px;
      }

      .grading-gap {
        height: 4px;

        flex-shrink: 0;
      }

      /* =====================================================
         SIGNATURE - BOTTOM
         ===================================================== */

      .signature-area {
        display: flex;

        justify-content: space-between;

        align-items: flex-end;

        margin-top: auto;

        padding: 0 45px 10px;

        page-break-inside: avoid;

        break-inside: avoid;

        flex-shrink: 0;
      }

      .signature {
        width: 175px;

        text-align: center;

        padding-top: 0;

        font-size: 8px;

        line-height: 11px;
      }

      .signature-line {
        width: 175px;

        border-top: 1px solid #333;

        margin: 0 auto 4px;
      }

      .principal-signature {
        display: block;

        width: 120px;

        height: 52px;

        object-fit: contain;

        object-position: center bottom;

        margin: 0 auto 1px;
      }


      /* =====================================================
         REFERENCE LAYOUT - SAFE TEXT / LINE SPACING
         Keep clear space above and below every bordered line.
         Text/content is intentionally NOT changed here.
         ===================================================== */

      .report-card {
        /* Pull the complete report-card content upward to use the
           previously unused top space and preserve more room below. */
        padding: 2px 15px 17px;
        box-sizing: border-box;
      }

      .school-header {
        min-height: 124px;
        padding: 0 8px 6px;
        box-sizing: border-box;
      }

      .school-name {
        line-height: 38px;
      }

      .affiliation {
        margin-top: 3px;
        line-height: 15px;
      }

      .school-address {
        margin-top: 3px;
        line-height: 16px;
      }

      .school-contact {
        margin-top: 4px;
        line-height: 13px;
      }

      .session-report {
        padding: 4px 0 6px;
      }

      .session-title {
        line-height: 14px;
      }

      .report-title {
        line-height: 15px;
        margin-top: 1px;
      }

      .student-info {
        padding: 7px 24px 7px;
        row-gap: 4px;
      }

      .student-detail {
        line-height: 13px;
        min-height: 13px;
      }

      .section-title {
        padding: 6px 5px 5px;
        line-height: 14px;
      }

      .marks-table {
        margin-top: 4px;
      }

      .marks-table th {
        padding: 4px 3px;
        line-height: 10px;
        height: 21px;
      }

      .marks-table td {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
        line-height: 11px !important;
      }

      .term-heading {
        height: 22px !important;
        padding: 4px !important;
        line-height: 12px !important;
      }

      .total-row td {
        height: 20px !important;
        padding: 4px 3px !important;
        line-height: 10px !important;
      }

      .percentage-row td {
        height: 23px;
        padding: 5px 6px;
        line-height: 12px;
      }

      .small-table th {
        padding: 4px 4px;
        height: 21px;
        line-height: 10px;
      }

      .small-table td {
        padding: 4px 5px;
        height: 22px;
        line-height: 11px;
      }

      .co-table th {
        height: 23px !important;
        padding: 5px 5px !important;
        line-height: 11px !important;
      }

      .co-table td {
        height: 24px !important;
        padding: 5px 5px !important;
        line-height: 12px !important;
      }

      .result-row {
        margin-top: 6px;
        padding: 6px 7px;
        min-height: 27px;
        line-height: 13px;
        box-sizing: border-box;
      }

      .remark-row {
        margin-top: 5px;
        min-height: 34px;
        padding: 6px 7px;
        line-height: 13px;
        box-sizing: border-box;
      }

      .grading-table th,
      .grading-table td {
        padding: 4px 3px;
        height: 18px;
        line-height: 10px;
      }

      .grading-table tr:first-child th {
        height: 20px;
        padding: 4px 3px;
        line-height: 11px;
      }

      .grading-gap {
        height: 6px;
      }

      .signature-area {
        padding: 0 45px 13px;
      }

      .signature-line {
        margin-bottom: 5px;
      }


      /* =====================================================
         FINAL REFERENCE ADJUSTMENTS
         ===================================================== */

      .school-name {
        font-size: 29px !important;
        line-height: 40px !important;
      }

      /* Section headings sit on the left like the reference. */
      .section-title {
        text-align: left !important;
        padding: 6px 7px 6px !important;
        line-height: 14px !important;
      }

      /* Give the complete scholastic header more vertical breathing room. */
      .marks-table th {
        padding: 5px 4px !important;
        height: 24px !important;
        line-height: 11px !important;
      }

      .marks-table .term-heading {
        height: 25px !important;
        padding: 5px 4px !important;
        line-height: 13px !important;
      }

      .marks-table td {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        line-height: 12px !important;
      }

      .total-row td {
        height: 22px !important;
        padding: 5px 4px !important;
        line-height: 11px !important;
      }

      .percentage-row td {
        height: 25px !important;
        padding: 6px 7px !important;
        line-height: 13px !important;
        text-align: left !important;
      }

      /* Foundation table: more space above/below each line. */
      .small-table th {
        height: 24px !important;
        padding: 5px 5px !important;
        line-height: 11px !important;
      }

      .small-table td {
        height: 25px !important;
        padding: 5px 6px !important;
        line-height: 12px !important;
      }

      .foundation-name {
        text-align: left !important;
      }

      /* Co-Scholastic table */
      .co-table th {
        height: 25px !important;
        padding: 5px 6px !important;
        line-height: 12px !important;
      }

      .co-table td {
        height: 26px !important;
        padding: 5px 6px !important;
        line-height: 13px !important;
      }

      .co-table th:first-child {
        text-align: left !important;
      }

      .co-area {
        text-align: left !important;
      }

      /* Grading scale headings on the left, like the reference. */
      .grading-table tr:first-child th {
        text-align: left !important;
        padding-left: 7px !important;
        height: 22px !important;
      }

      .grading-table th,
      .grading-table td {
        padding: 4px 3px !important;
        height: 19px !important;
        line-height: 10px !important;
      }

      /* Keep the two grading tables visually separated. */
      .grading-gap {
        height: 7px !important;
      }

      /* Slightly more bottom breathing room for signatures. */
      .signature-area {
        padding-bottom: 15px !important;
      }


      /* =====================================================
         FINAL REPORT CARD POLISH - REFERENCE MATCH
         ===================================================== */

      /* More breathing room between the page edge and the
         complete report-card border/content. */
      .report-card {
        padding: 17px 20px 20px !important;
      }

      /* Keep all table text vertically centered with equal
         top/bottom breathing room. */
      .marks-table th,
      .marks-table td,
      .small-table th,
      .small-table td,
      .co-table th,
      .co-table td,
      .grading-table th,
      .grading-table td {
        vertical-align: middle !important;
      }

      .marks-table th {
        padding: 6px 4px !important;
        line-height: 12px !important;
        height: 26px !important;
      }

      .marks-table .term-heading {
        padding: 6px 4px !important;
        line-height: 13px !important;
        height: 27px !important;
      }

      .marks-table td {
        padding: 6px 4px !important;
        line-height: 12px !important;
        height: 25px !important;
      }

      .marks-table .subject-cell {
        padding-left: 7px !important;
        padding-right: 7px !important;
      }

      .total-row td {
        padding: 6px 4px !important;
        line-height: 12px !important;
        height: 25px !important;
      }

      /* Percentage must be on the RIGHT side. */
      .percentage-row td {
        text-align: right !important;
        padding: 6px 9px !important;
        line-height: 13px !important;
        height: 27px !important;
      }

      /* Scholastic Areas gets a complete horizontal line
         above the heading, across the full report width. */
      .section-title {
        text-align: left !important;
        border-top: 1px solid #777 !important;
        padding: 7px 7px 6px !important;
        line-height: 14px !important;
        min-height: 28px;
        box-sizing: border-box;
      }

      /* Student details: no underline on Father/Class values. */
      .student-value-underline {
        text-decoration: none !important;
      }

      /* Foundation table: equal top/bottom spacing. */
      .small-table th {
        padding: 6px 5px !important;
        line-height: 12px !important;
        height: 26px !important;
      }

      .small-table td {
        padding: 6px 6px !important;
        line-height: 12px !important;
        height: 26px !important;
      }

      /* Co-Scholastic table: equal vertical spacing. */
      .co-table th {
        padding: 6px 6px !important;
        line-height: 12px !important;
        height: 27px !important;
      }

      .co-table td {
        padding: 6px 6px !important;
        line-height: 13px !important;
        height: 28px !important;
      }

      /* Remark must stay on the LEFT. */
      .remark-row {
        text-align: left !important;
        padding: 7px 9px !important;
        min-height: 36px !important;
        line-height: 14px !important;
        box-sizing: border-box;
      }

      .remark-row strong {
        text-align: left !important;
      }

      /* The small grading tables at the bottom are increased
         so their text is clearly readable in the final PDF. */
      .grading-table th,
      .grading-table td {
        font-size: 8px !important;
        line-height: 11px !important;
        padding: 5px 3px !important;
        height: 21px !important;
      }

      .grading-table tr:first-child th {
        font-size: 8.2px !important;
        line-height: 12px !important;
        padding: 5px 4px !important;
        height: 23px !important;
      }

      .grading-gap {
        height: 8px !important;
      }

      /* Keep the signature area away from the inner page edge. */
      .signature-area {
        padding: 0 48px 16px !important;
      }


      /* =====================================================
         FINAL CLIENT TYPOGRAPHY + FOUNDATION TABLE
         ===================================================== */

      /* School name: explicitly 26px as requested. */
      .school-name {
        font-size: 26px !important;
        line-height: 38px !important;
      }

      /* Increase remaining report-card text by ~1px. */
      .affiliation {
        font-size: 12px !important;
        line-height: 15px !important;
      }

      .school-address {
        font-size: 13px !important;
        line-height: 16px !important;
      }

      .school-contact {
        font-size: 10.5px !important;
        line-height: 13px !important;
      }

      .session-title {
        font-size: 12px !important;
        line-height: 15px !important;
      }

      .report-title {
        font-size: 13px !important;
        line-height: 16px !important;
      }

      .student-detail {
        font-size: 10px !important;
        line-height: 14px !important;
      }

      .section-title {
        font-size: 11px !important;
        line-height: 15px !important;
      }

      .marks-table th {
        font-size: 8.5px !important;
      }

      .marks-table .term-heading {
        font-size: 10px !important;
      }

      .total-row td {
        font-size: 8.5px !important;
      }

      .percentage-row td {
        font-size: 9px !important;
      }

      /* Foundation Exam exactly in the supplied reference:
         straight outer/inner borders, MARKS spanning MM + OM,
         equal vertical breathing room and centered values. */
      .small-table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
        table-layout: fixed !important;
      }

      .small-table th,
      .small-table td {
        border: 1px solid #777 !important;
        box-sizing: border-box !important;
        vertical-align: middle !important;
      }

      .small-table th {
        font-size: 8.5px !important;
        line-height: 12px !important;
        padding: 6px 5px !important;
        height: 27px !important;
      }

      .small-table td {
        font-size: 9px !important;
        line-height: 13px !important;
        padding: 6px 6px !important;
        height: 27px !important;
      }

      .foundation-name {
        text-align: left !important;
        vertical-align: middle !important;
      }

      .co-table th {
        font-size: 9px !important;
        line-height: 13px !important;
      }

      .co-table td {
        font-size: 9.5px !important;
        line-height: 14px !important;
      }

      .result-row {
        font-size: 9.5px !important;
        line-height: 13px !important;
      }

      .remark-row {
        font-size: 9.5px !important;
        line-height: 14px !important;
      }

      .grading-table th,
      .grading-table td {
        font-size: 9px !important;
        line-height: 12px !important;
        vertical-align: middle !important;
      }

      .signature {
        font-size: 9px !important;
        line-height: 12px !important;
      }

      /* Keep all borders straight and consistent. */
      .marks-table,
      .small-table,
      .grading-table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      .marks-table th,
      .marks-table td,
      .grading-table th,
      .grading-table td {
        border: 1px solid #777 !important;
      }


      .foundation-table .foundation-title-cell {
        text-align: left !important;
        padding-left: 7px !important;
        vertical-align: middle !important;
        font-weight: 700 !important;
      }

      .grading-table {
        width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
      }

      .grading-table .grading-label {
        width: 72px !important;
        min-width: 72px !important;
        white-space: nowrap !important;
        text-align: left !important;
        padding-left: 7px !important;
        padding-right: 5px !important;
      }

      .grading-table th,
      .grading-table td {
        box-sizing: border-box !important;
        vertical-align: middle !important;
        text-align: center !important;
        white-space: nowrap !important;
      }

      .grading-table .grading-label {
        text-align: left !important;
      }


      /* =====================================================
         FINAL CO-SCHOLASTIC GRADING TABLE FIX
         ===================================================== */

      .grading-table.co-grading-table {
        width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
      }

      .co-grading-table .grading-label {
        width: 92px !important;
        min-width: 92px !important;
        max-width: 92px !important;
        white-space: nowrap !important;
        overflow: visible !important;
        text-align: left !important;
        padding: 4px 6px !important;
        vertical-align: middle !important;
      }

      .co-grading-table th,
      .co-grading-table td {
        box-sizing: border-box !important;
        vertical-align: middle !important;
        text-align: center !important;
        white-space: nowrap !important;
        padding: 4px 2px !important;
        overflow: hidden !important;
      }

      /* Marks Range - FINAL FIX */
.co-grading-table th.grading-label {
  width: 105px !important;
  min-width: 105px !important;
  max-width: 105px !important;

  font-size: 7px !important;
  font-weight: 600 !important;

  white-space: nowrap !important;
  word-break: keep-all !important;
  overflow: visible !important;

  text-align: right !important;
  vertical-align: middle !important;

  padding: 4px 8px 4px 4px !important;
  box-sizing: border-box !important;
}

/* First column fixed so "Marks Range" is fully visible */
.co-grading-table tr > th:first-child {
  width: 105px !important;
  min-width: 105px !important;
  max-width: 105px !important;
}
/* Marks Range column - smaller font */
.co-grading-table tr > th:first-child {
  font-size: 8px !important;
}
/* Remaining columns stay centered */
.co-grading-table tr > th:not(:first-child),
.co-grading-table tr > td:not(:first-child) {
  width: auto !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
}

      /* Make every internal vertical/horizontal border meet exactly. */
      .co-grading-table th,
      .co-grading-table td {
        border: 1px solid #999 !important;
      }

      /* The small grading tables should not leave gaps between cells. */
      .grading-table tr {
        height: auto !important;
      }

      /* Keep the first label column separate from the numeric columns. */
      .co-grading-table .grading-label + th,
      .co-grading-table .grading-label + td {
        border-left: 1px solid #999 !important;
      }


      .marks-table,
      .small-table,
      .co-table,
      .grading-table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
        width: 100% !important;
      }

      .marks-table th,
      .marks-table td,
      .small-table th,
      .small-table td,
      .co-table th,
      .co-table td,
      .grading-table th,
      .grading-table td {
        border-left: 1px solid #999 !important;
        border-right: 1px solid #999 !important;
      }

      .marks-table tr,
      .small-table tr,
      .co-table tr,
      .grading-table tr {
        border-spacing: 0 !important;
      }

    
      /* =====================================================
         FINAL ALIGNMENT ONLY
         Keep existing spacing/padding unchanged.
         All report-card cell content vertically centered.
         Section/report headings horizontally centered.
         ===================================================== */

      .report-card table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      .report-card th,
      .report-card td {
        vertical-align: middle !important;
      }

      .report-card .marks-table th,
      .report-card .marks-table td,
      .report-card .small-table th,
      .report-card .small-table td,
      .report-card .co-table th,
      .report-card .co-table td,
      .report-card .grading-table th,
      .report-card .grading-table td {
        vertical-align: middle !important;
      }

      /* Keep actual cell layout as table-cell so vertical-align
         works correctly in html2canvas/PDF rendering. */
      .report-card th,
      .report-card td {
        display: table-cell !important;
      }

      /* Horizontal center for report-card headings */
      .report-card .school-header,
      .report-card .school-name,
      .report-card .affiliation,
      .report-card .school-address,
      .report-card .school-contact,
      .report-card .session-report,
      .report-card .session-title,
      .report-card .report-title,
      .report-card .section-title,
      .report-card .term-heading,
      .report-card .marks-table th,
      .report-card .small-table th,
      .report-card .co-table th,
      .report-card .grading-table th {
        text-align: center !important;
      }

      /* Center heading text even when a previous rule sets alignment */
      .report-card .section-title {
        width: 100%;
        box-sizing: border-box;
      }

      /* Student information stays vertically centered */
      .report-card .student-detail {
        min-height: 12px;
        display: flex;
        align-items: center;
      }

      /* Result / percentage / remark text is vertically centered
         without changing the existing spacing. */
      .report-card .result-row,
      .report-card .remark-row {
        display: flex;
        align-items: center;
      }

      .report-card .percentage-row td {
        vertical-align: middle !important;
        text-align: center !important;
      }

      /* Signature text remains centered and vertically aligned */
      .report-card .signature {
        text-align: center !important;
      }


      /* =====================================================
         FINAL CLIENT UPDATE - REFERENCE SCHOOL HEADER
         ===================================================== */

      @font-face {
        font-family: "EdwardianScriptITC";
        src: url("${edwardianFont}") format("truetype");
        font-weight: normal;
        font-style: normal;
      }

      /* Exact reference school-name font */
      .report-card .school-name {
  font-family: "EdwardianScriptITC", cursive !important;
  font-size: 32px !important;
  line-height: 44px !important;
  font-weight: bold !important;
  font-style: italic !important;
  text-align: center !important;
  transform: translate(35px, -5px) !important;
  white-space: nowrap !important;
}

      /* Move school details slightly to the right without changing
         their original spacing/heights. */
      .report-card .affiliation,
      .report-card .school-address,
      .report-card .school-contact {
        transform: translate(20px, -5px);
        text-align: center !important;
      }

      /* Keep the school logo exactly where it is. */
      .report-card .school-logo {
        top: 0 !important;
        transform: none !important;
      }

      /* Foundation Exam MARKS heading slightly more to the right.
         Text-indent moves only the text, not the table columns. */
      .report-card .foundation-table th[colspan="2"] {
        text-indent: 155px !important;
        text-align: center !important;
      }

      /* Keep MM / OM centered in their own cells. */
      .report-card .foundation-table th:not([colspan]),
      .report-card .foundation-table td {
        vertical-align: middle !important;
      }

      /* =====================================================
         FINAL CLIENT UPDATE
         - Percentage strictly RIGHT aligned
         - Co-Scholastic Areas table 70 : 30
         ===================================================== */

      .report-card .percentage-row td {
        text-align: right !important;
        vertical-align: middle !important;
        padding-left: 6px !important;
        padding-right: 9px !important;
      }

      .report-card .co-table {
        width: 100% !important;
        table-layout: fixed !important;
      }

      .report-card .co-table col:first-child {
        width: 70% !important;
      }

      .report-card .co-table col:last-child {
        width: 30% !important;
      }

      .report-card .co-table th:first-child,
      .report-card .co-table td:first-child {
        width: 70% !important;
        text-align: left !important;
        vertical-align: middle !important;
      }

      .report-card .co-table th:last-child,
      .report-card .co-table td:last-child {
        width: 30% !important;
        text-align: center !important;
        vertical-align: middle !important;
      }


      /* =====================================================
         FINAL REPORT-CARD TYPOGRAPHY
         From Academic Session / Admission details onward:
         increase report-card content by exactly +2px.
         School header/name is intentionally excluded.
         ===================================================== */

      .report-card .session-title {
        font-size: 14px !important;
        line-height: 17px !important;
      }

      .report-card .report-title {
        font-size: 15px !important;
        line-height: 18px !important;
      }

      .report-card .student-detail {
        font-size: 12px !important;
        line-height: 16px !important;
      }

      .report-card .section-title {
        font-size: 13px !important;
        line-height: 17px !important;
      }

      .report-card .marks-table th {
        font-size: 10.5px !important;
        line-height: 11px !important;
      }

      .report-card .marks-table .term-heading {
        font-size: 12px !important;
        line-height: 13px !important;
      }

      .report-card .marks-table td {
        line-height: 13px !important;
      }

      .report-card .total-row td {
        font-size: 10.5px !important;
      }

      .report-card .percentage-row td {
        font-size: 11px !important;
      }

      .report-card .small-table th {
        font-size: 10.5px !important;
        line-height: 14px !important;
      }

      .report-card .small-table td {
        font-size: 11px !important;
        line-height: 15px !important;
      }

      .report-card .co-table th {
        font-size: 11px !important;
        line-height: 15px !important;
      }

      .report-card .co-table td {
        font-size: 11.5px !important;
        line-height: 16px !important;
      }

      .report-card .result-row {
        font-size: 11.5px !important;
        line-height: 15px !important;
      }

      .report-card .remark-row {
        font-size: 11.5px !important;
        line-height: 16px !important;
      }

      .report-card .grading-table th,
      .report-card .grading-table td {
        font-size: 11px !important;
        line-height: 14px !important;
      }

      .report-card .grading-table tr:first-child th {
        font-size: 10.2px !important;
        line-height: 14px !important;
      }

      .report-card .signature {
        font-size: 11px !important;
        line-height: 14px !important;
      }

      .report-card .no-data-cell {
        font-size: 7px !important;
        line-height: 13px !important;
      }
</style>

    <div class="report-card">

      <!-- =================================================
           SCHOOL HEADER
           ================================================= -->

      <div class="school-header">

        <img
          src="${schoolLogo}"
          class="school-logo"
          crossorigin="anonymous"
        />

        <div class="school-name">
          Cosmonaut International School, Barasari
        </div>

        <div class="affiliation">
          Affiliated to CBSE (NEW Delhi)
          &nbsp;&nbsp;
          Affiliation No.532233
        </div>

        <div class="school-address">
          Jamal Chopta Road, Barasari, Sirsa
        </div>

        <div class="school-contact">
          Ph.No: 9781098792
          &nbsp;&nbsp;
          Email: info@cosmonaut.co.in
        </div>

      </div>

      <!-- =================================================
           SESSION
           ================================================= -->

      <div class="session-report">

        <div class="session-title">
          Academic Session:
          ${safeValue(
            reportAcademicSession
          )}
        </div>

        <div class="report-title">
          Report Card
        </div>

      </div>

      <!-- =================================================
           STUDENT DETAILS
           ================================================= -->

      <div class="student-info">

        <div class="student-detail">
          <span class="student-label">
            Student's Name
          </span>
          &nbsp;:
          ${safeValue(
            studentName
          )}
        </div>

        <div class="student-detail">
          <span class="student-label">
            Admission No.
          </span>
          &nbsp;:
          ${safeValue(
            admissionNo
          )}
        </div>

        <div class="student-detail">
          <span class="student-label">
            Father's Name
          </span>
          &nbsp;:
          ${safeValue(
              fatherName
            )}
        </div>

        <div class="student-detail">
          <span class="student-label">
            Class & Sec
          </span>
          &nbsp;:
          ${safeValue(
              className
            )}
          -
          ${safeValue(
              sectionName
            )}
        </div>

      </div>

      <!-- =================================================
           SCHOLASTIC AREAS
           ================================================= -->

      <div class="section-title">
        Scholastic Areas
      </div>

      <table class="marks-table">

        <colgroup>

          ${
            isEarlyYears
              ? `
                <col style="width:28%;" />
                <col style="width:14%;" />
                <col style="width:14%;" />
                <col style="width:16%;" />
                <col style="width:17%;" />
                <col style="width:11%;" />
              `
              : `
                <col style="width:34%;" />
                <col style="width:18%;" />
                <col style="width:20%;" />
                <col style="width:17%;" />
                <col style="width:11%;" />
              `
          }

        </colgroup>

        <thead>

          <tr>

            <th
              colspan="${isEarlyYears ? 6 : 5}"
              class="term-heading"
            >
              ${safeValue(
                examName
              )}
            </th>

          </tr>

          <tr>

            <th>
              SUBJECT
            </th>

            <th>
              ${
                isEarlyYears
                  ? `WRITTEN<br/>(${reportWrittenMaximum})`
                  : `SA<br/>(80)`
              }
            </th>

            ${
              isEarlyYears
                ? `
                  <th>
                    ORAL<br/>(${reportOralMaximum})
                  </th>
                `
                : ""
            }

            <th>
              ${
                isEarlyYears
                  ? `ASSESSMENT<br/>(${reportAssessmentMaximum})`
                  : `Assessment<br/>(20)`
              }
            </th>

            <th>
              Total<br/>(${isEarlyYears
                ? subjectData[0]?.maximum || 0
                : 100})
            </th>

            <th>
              Grade
            </th>

          </tr>

        </thead>

        <tbody>

          ${
            subjectRows ||
            `
              <tr>

                <td
                  colspan="${isEarlyYears ? 6 : 5}"
                  style="
                    text-align:center;
                    padding:5px;
                    line-height:11px;
                  "
                >
                  No Subjects Available
                </td>

              </tr>
            `
          }

          <!-- TOTAL -->

          <tr class="total-row">

            <td
              class="subject-cell"
              style="
                text-align:right;
              "
            >
              Total
            </td>

            <td class="marks-cell">
              ${totalSA}
            </td>

            ${
              isEarlyYears
                ? `
                  <td class="marks-cell">
                    ${totalOral}
                  </td>
                `
                : ""
            }

            <td class="marks-cell">
              ${totalAssessment}
            </td>

            <td class="marks-cell">
              ${totalObtained}
            </td>

            <td class="marks-cell">
              ${
                overallGrade ||
                "-"
              }
            </td>

          </tr>

          <!-- OVERALL PERCENTAGE -->

          <tr class="percentage-row">

            <td colspan="${isEarlyYears ? 6 : 5}">

              ${safeValue(examName || "Term-Cosmonaut International School, Barasari, Sirsa")} Percentage:
              ${overallPercentage}%

            </td>

          </tr>

        </tbody>

      </table>

      ${
        foundationAllowed
          ? `
            <!-- =================================================
                 FOUNDATION
                 ONLY CLASS 4-10
                 ================================================= -->

            <table class="small-table foundation-table">

              <colgroup>

                <col style="width:58%;" />

                <col style="width:21%;" />

                <col style="width:21%;" />

              </colgroup>

              <thead>

                <tr>

                  <th class="foundation-title-cell">
                    Foundation Exam
                  </th>

                  <th colspan="2">
                    MARKS
                  </th>

                </tr>

                <tr>

                  <th></th>

                  <th>
                    MM
                  </th>

                  <th>
                    OM
                  </th>

                </tr>

              </thead>

              <tbody>

                ${foundationRows}

              </tbody>

            </table>
          `
          : ""
      }

      <!-- =================================================
           CO-SCHOLASTIC
           ================================================= -->

      <div class="section-title">

        Co-Scholastic Areas

      </div>

      <table class="small-table co-table">

        <colgroup>

          <col style="width:70%;" />

          <col style="width:30%;" />

        </colgroup>

        <thead>

          <tr>

            <th
              style="
                text-align:left;
              "
            >
              Area
            </th>

            <th>
              Grade
            </th>

          </tr>

        </thead>

        <tbody>

          ${coScholasticRows}

        </tbody>

      </table>

      <!-- =================================================
           REMARK
           ================================================= -->

      <div class="remark-row">

        <strong>
          Remark
        </strong>

        &nbsp;:

        ${safeValue(
          resultStudent?.remark ||
            actualStudent?.remark ||
            "",
          ""
        )}

      </div>


      <!-- =================================================
           SCHOLASTIC GRADING SCALE
           ================================================= -->

      <table class="grading-table">

        <tr>

          <th colspan="8">
            Scholastic Grading Scale
          </th>

        </tr>

        <tr>

          <th>
            Grade
          </th>

          <th>A1</th>
          <th>A2</th>
          <th>B1</th>
          <th>B2</th>
          <th>C1</th>
          <th>C2</th>
          <th>D</th>

        </tr>

        <tr>

          <th>
            Marks Range
          </th>

          <td>
            91-100
          </td>

          <td>
            81-90
          </td>

          <td>
            71-80
          </td>

          <td>
            61-70
          </td>

          <td>
            51-60
          </td>

          <td>
            41-50
          </td>

          <td>
            33-40
          </td>

        </tr>

      </table>

      <div class="grading-gap"></div>

      <!-- =================================================
           CO-SCHOLASTIC GRADING SCALE
           ================================================= -->

      <table class="grading-table co-grading-table">

        <tr>

          <th colspan="14">
            Co Scholastic Grading Scale
          </th>

        </tr>

        <tr>

          <th>
            Grade
          </th>

          <th>A1</th>
          <th>A2</th>
          <th>B1</th>
          <th>B2</th>
          <th>C1</th>
          <th>C2</th>

          <th>A1</th>
          <th>A2</th>
          <th>B1</th>
          <th>B2</th>
          <th>C1</th>
          <th>C2</th>
          <th>D</th>

        </tr>

        <tr>

          <th class="grading-label">
            Marks Range
          </th>

          <td>
            5.1-6.0
          </td>

          <td>
            4.1-5.0
          </td>

          <td>
            3.1-4.0
          </td>

          <td>
            2.1-3.0
          </td>

          <td>
            1.1-2.0
          </td>

          <td>
            0.0-1.0
          </td>

          <td>
            45.5-50.0
          </td>

          <td>
            40.5-45.4
          </td>

          <td>
            35.5-40.4
          </td>

          <td>
            30.5-35.4
          </td>

          <td>
            25.5-30.4
          </td>

          <td>
            20.5-25.4
          </td>

          <td>
            16.5-20.4
          </td>

        </tr>

      </table>

      <!-- =================================================
           SIGNATURE - ABSOLUTE LAST
           ================================================= -->

      <div class="signature-area">

        <div class="signature">
          <div class="signature-line"></div>
          Signature of Class Teacher
        </div>

        <div class="signature">
          <img
            src="${principalSignature}"
            class="principal-signature"
            alt="Principal Signature"
          />
          <div class="signature-line"></div>
          Signature of Principal
        </div>

      </div>

    </div>
    /* Co-Scholastic - Grade column wider */
.report-card .co-table th:last-child,
.report-card .co-table td:last-child {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
  text-align: center !important;
  vertical-align: middle !important;
}
  `;

  container.appendChild(
    card
  );

  // =========================================================
  // GENERATE PDF
  // =========================================================

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: "a4",
  });

  try {
    if (document.fonts?.ready) {
      await document.fonts.ready;
    }

    const canvas =
      await html2canvas(
        card,
        {
          scale: 2,

          useCORS: true,

          backgroundColor:
            "#ffffff",

          logging: false,
        }
      );

    const imgData =
      canvas.toDataURL(
        "image/png"
      );

    const imgProps =
      pdf.getImageProperties(
        imgData
      );

    const pdfWidth =
      pdf.internal.pageSize.getWidth();

    const pdfHeight =
      (imgProps.height *
        pdfWidth) /
      imgProps.width;

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      pdfWidth,
      pdfHeight
    );

    container.innerHTML = "";

    pdf.save(
      `ReportCard_${String(
        studentName
      )
        .replace(
          /\s+/g,
          "_"
        )
        .replace(
          /[^a-zA-Z0-9_-]/g,
          ""
        )}.pdf`
    );
  } catch (error) {
    console.error(
      "PDF generation error:",
      error
    );

    container.innerHTML = "";

    alert(
      "Unable to generate PDF. Please try again."
    );
  }
};
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6">
      {/* FORM GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        <div>
          <label className={labelStyle}>Class</label>
          <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} className={inputBase} style={inputBorder}>
            <option value="">Select Class</option>
            {classes.map(c => <option key={c._id} value={c.className}>{c.className}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Section</label>
          <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} disabled={!selectedClass} className={inputBase} style={inputBorder}>
            <option value="">Select Section</option>
            {sections.map(s => <option key={s._id} value={s.sectionName}>{s.sectionName}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Exam</label>
          <select value={selectedExam} onChange={e => setSelectedExam(e.target.value)} className={inputBase} style={inputBorder}>
            <option value="">Select Exam</option>
            {exams.map(e => <option key={e._id} value={e.examName}>{e.examName}</option>)}
          </select>
        </div>
      </div>

      {/* SUBJECTS */}
      <h2 className="font-semibold text-black mb-4" style={{ fontSize: "18px" }}>Subjects & Total Marks</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        {subjects.map(sub => (
          <div key={sub._id}>
            <label className={labelStyle}>{sub.subjectName}</label>
            <input type="number" value={subjectMarks[sub.subjectName] ?? ""} onChange={e => handleSubjectMarksChange(sub.subjectName, e.target.value)} className={inputBase} style={inputBorder} />
          </div>
        ))}
      </div>

{/* STUDENT SCORES */}
<h2
  className="font-semibold text-black mb-4"
  style={{ fontSize: "18px" }}
>
  Student Scores
</h2>

<div className="overflow-x-auto mb-8">
  <table className="min-w-full border border-gray-300 text-left">
    <thead className="bg-gray-200">
      <tr>
        <th rowSpan={2} className="px-4 py-3 text-[18px] border">#</th>
        <th rowSpan={2} className="px-4 py-3 text-[18px] border">Roll</th>
        <th rowSpan={2} className="px-4 py-3 text-[18px] border">Name</th>

        {subjects.map((sub) => (
          <th
            key={sub._id}
            className="px-4 py-3 text-[18px] text-center border"
          >
            {sub.subjectName}
          </th>
        ))}

        {coScholasticAreas.map((area) => (
          <th
            key={`co-head-${area}`}
            rowSpan={2}
            className="px-4 py-3 text-[18px] text-center border min-w-[130px]"
          >
            {area}
          </th>
        ))}

        <th rowSpan={2} className="px-4 py-3 text-[18px] text-center border">
          Total
        </th>

        <th rowSpan={2} className="px-4 py-3 text-[18px] text-center border">
          %
        </th>

        <th rowSpan={2} className="px-4 py-3 text-[18px] border">
          Remark
        </th>
      </tr>

      <tr>
        {subjects.map((sub) => (
          <th
            key={`${sub._id}-labels`}
            className="px-2 py-2 border text-center"
          >
            {isNurseryLkgUkg(selectedClass) ? (
              <div className="flex flex-col">
                <span className="text-sm font-semibold">Written</span>
                <span className="text-sm font-semibold">Oral</span>
                <span className="text-sm font-semibold">Assessment</span>
              </div>
            ) : (
              <div className="flex flex-col">
                <span className="text-sm font-semibold">SA</span>
                <span className="text-sm font-semibold">Assessment</span>
              </div>
            )}
          </th>
        ))}
      </tr>
    </thead>

    <tbody>
      {students.length ? (
        students.map((st, i) => {
          const earlyYears = isNurseryLkgUkg(selectedClass);
          const inputRowSpan = earlyYears ? 3 : 2;

          return (
            <React.Fragment key={st._id}>

              {/* WRITTEN / SA ROW */}
              <tr className="bg-white">

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 text-[14px] border align-middle"
                >
                  {i + 1}
                </td>

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 text-[14px] border align-middle"
                >
                  {st.rollNo}
                </td>

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 text-[14px] font-medium border align-middle"
                >
                  {`${st.firstName} ${st.lastName}`}
                </td>

                {subjects.map((sub) => (
                  <td
                    key={`${st._id}-${sub._id}-written`}
                    className="px-3 py-2 border"
                  >
                    <input
                      type="number"
                      min="0"
                      value={
                        scores[st._id]?.[sub.subjectName]?.sa ?? ""
                      }
                      onChange={(e) =>
                        handleSAMarksChange(
                          st._id,
                          sub.subjectName,
                          e.target.value
                        )
                      }
                      className="w-full min-w-[90px] text-[14px] bg-white px-3 py-2 rounded-lg"
                      style={inputBorder}
                      placeholder={
                        earlyYears
                          ? "Written"
                          : "SA"
                      }
                    />
                  </td>
                ))}

                {coScholasticAreas.map((area) => (
                  <td
                    key={`${st._id}-co-${area}`}
                    rowSpan={inputRowSpan}
                    className="px-3 py-2 border align-middle"
                  >
                    <select
                      value={coGrades[st._id]?.[area] ?? ""}
                      onChange={(e) =>
                        handleCoGradeChange(
                          st._id,
                          area,
                          e.target.value
                        )
                      }
                      className="w-full min-w-[110px] text-[14px] bg-white px-3 py-2 rounded-lg"
                      style={inputBorder}
                    >
                      <option value="">Grade</option>
                      <option value="A+">A+</option>
                      <option value="A">A</option>
                      <option value="B+">B+</option>
                      <option value="B">B</option>
                      <option value="C+">C+</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                    </select>
                  </td>
                ))}

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 text-[15px] font-semibold text-center border align-middle"
                >
                  {calculateTotal(st._id)}
                </td>

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 text-[15px] font-semibold text-center border align-middle"
                >
                  {calculatePercentage(st._id)}%
                </td>

                <td
                  rowSpan={inputRowSpan}
                  className="px-4 py-2 border align-middle"
                >
                  <input
                    type="text"
                    value={remarks[st._id] ?? ""}
                    onChange={(e) =>
                      handleRemarkChange(
                        st._id,
                        e.target.value
                      )
                    }
                    className="w-40 text-[14px] bg-white px-3 py-2 rounded-lg"
                    style={inputBorder}
                    placeholder="Remark"
                  />
                </td>
              </tr>

              {earlyYears && (
                /* ORAL ROW */
                <tr className="bg-gray-50">
                  {subjects.map((sub) => (
                    <td
                      key={`${st._id}-${sub._id}-oral`}
                      className="px-3 py-2 border"
                    >
                      <input
                        type="number"
                        min="0"
                        value={
                          scores[st._id]?.[sub.subjectName]?.oral ?? ""
                        }
                        onChange={(e) =>
                          handleOralMarksChange(
                            st._id,
                            sub.subjectName,
                            e.target.value
                          )
                        }
                        className="w-full min-w-[90px] text-[14px] bg-white px-3 py-2 rounded-lg"
                        style={inputBorder}
                        placeholder="Oral"
                      />
                    </td>
                  ))}
                </tr>
              )}

              {/* ASSESSMENT ROW */}
              <tr className="bg-gray-50">
                {subjects.map((sub) => (
                  <td
                    key={`${st._id}-${sub._id}-assessment`}
                    className="px-3 py-2 border"
                  >
                    <input
                      type="number"
                      min="0"
                      value={
                        scores[st._id]?.[sub.subjectName]?.assessment ?? ""
                      }
                      onChange={(e) =>
                        handleAssessmentChange(
                          st._id,
                          sub.subjectName,
                          e.target.value
                        )
                      }
                      className="w-full min-w-[90px] text-[14px] bg-white px-3 py-2 rounded-lg"
                      style={inputBorder}
                      placeholder="Assessment"
                    />
                  </td>
                ))}
              </tr>

            </React.Fragment>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={subjects.length + coScholasticAreas.length + 6}
            className="px-4 py-6 text-center text-gray-500"
          >
            No students found
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

      {/* BUTTONS */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button
  onClick={handleSubmit}
  disabled={loading}
  className="text-white"
  style={{
    ...button18,
    background: loading ? "#9ca3af" : colors.gradientPrimary,
    boxShadow: loading ? "none" : "0 4px 12px rgba(0,0,0,0.2)",
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.85 : 1,
  }}
>
  {loading
    ? "Please wait..."
    : isEditing
      ? "Update Result"
      : "Submit Result"}
</button>

        <button onClick={resetForm} className="bg-white border border-gray-300 hover:bg-gray-100" style={button18}>Reset</button>
      </div>
      {/* SAVED EXAM RESULTS */}
      <h2 className="font-semibold text-black mt-10 mb-4" style={{ fontSize: "18px" }}>Saved Exam Results</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 text-left">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-[18px]">#</th>
              <th className="px-4 py-2 text-[18px]">Class</th>
              <th className="px-4 py-2 text-[18px]">Section</th>
              <th className="px-4 py-2 text-[18px]">Exam</th>
              <th className="px-4 py-2 text-[18px]">Actions</th>
            </tr>
          </thead>
          <tbody>
            {examResults.length ? examResults.map((res, i) => (
              <tr key={res._id} className="even:bg-white odd:bg-gray-50">
                <td className="px-4 py-2 text-[14px]">{i + 1}</td>
                <td className="px-4 py-2 text-[14px]">{res.className}</td>
                <td className="px-4 py-2 text-[14px]">{res.sectionName}</td>
                <td className="px-4 py-2 text-[14px]">{res.examName}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEdit(res._id)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    style={{ fontSize: "14px" }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(res._id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    style={{ fontSize: "14px" }}
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => setViewingResult(res)}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                    style={{ fontSize: "14px" }}
                  >
                    View
                  </button>
                </td>
              </tr>
            )) : (
              <tr><td className="px-4 py-4 text-center" colSpan={5}>No results available</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* VIEW RESULT MODAL/SECTION */}
      {viewingResult && (
        <div className="mt-6 p-4 border border-gray-300 rounded bg-white">
          <h3 className="font-semibold text-[18px] mb-2">Exam: {viewingResult.examName}</h3>
          <p className="text-[14px] mb-2">Class: {viewingResult.className} | Section: {viewingResult.sectionName}</p>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-[14px]">#</th>
                  <th className="px-4 py-2 text-[14px]">Roll</th>
                  <th className="px-4 py-2 text-[14px]">Name</th>
                  {viewingResult.subjects.map((sub, idx) => (
                    <th key={idx} className="px-4 py-2 text-[14px]">{sub.subjectName}</th>
                  ))}
                  <th className="px-4 py-2 text-[14px]">Total</th>
                  <th className="px-4 py-2 text-[14px]">%</th>
                  <th className="px-4 py-2 text-[14px]">Remark</th>
                  {(viewingResult.coScholasticAreas || []).map((area, areaIndex) => (
                    <th key={`co-head-${areaIndex}`} className="px-4 py-2 text-[14px]">
                      {typeof area === "string" ? area : area?.name}
                    </th>
                  ))}
                  <th className="px-4 py-2 text-[14px]">Report Cards</th>
                </tr>
              </thead>
              <tbody>
                {viewingResult.students.map((st, idx) => {
                  const total = st.scores.reduce((sum, s) => {
                    const score =
                      Number(s.score);

                    const sa =
                      Number(s.sa) || 0;

                    const assessment =
                      Number(s.assessment) || 0;

                    return sum + (
                      Number.isFinite(score)
                        ? score
                        : sa + assessment
                    );
                  }, 0);
                  const maxTotal = viewingResult.subjects.reduce((sum, s) => sum + (parseFloat(s.totalMarks) || 0), 0);
                  const percentage = maxTotal ? ((total / maxTotal) * 100).toFixed(2) : "0.00";
                  return (
                    <tr key={st.studentId} className="even:bg-white odd:bg-gray-50">
                      <td className="px-4 py-2 text-[14px]">{idx + 1}</td>
                      <td className="px-4 py-2 text-[14px]">{st.rollNo}</td>
                      <td className="px-4 py-2 text-[14px]">{st.studentName}</td>
                      {st.scores.map((s, i) => <td key={i} className="px-4 py-2 text-[14px]">{s.score}</td>)}
                      <td className="px-4 py-2 text-[14px]">{total}</td>
                      <td className="px-4 py-2 text-[14px]">{percentage}%</td>
                      <td className="px-4 py-2 text-[14px]">{st.remark}</td>
                      {(viewingResult.coScholasticAreas || []).map((area, areaIndex) => {
                        const areaName = typeof area === "string" ? area : area?.name;
                        const coItem = (st.coScholastic || []).find(
                          (item) =>
                            String(item?.area || "").trim().toLowerCase() ===
                            String(areaName || "").trim().toLowerCase()
                        );
                        return (
                          <td key={`co-${areaIndex}`} className="px-4 py-2 text-[14px] text-center">
                            {coItem?.grade || "-"}
                          </td>
                        );
                      })}
                      <td>
                        <button
                          onClick={() => generatePDFReportCardForStudent(viewingResult, st.studentId)}
                          className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
                          style={{ fontSize: "14px" }}
                        >
                          Generate PDF Report Card
                        </button>
                      </td>


                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            onClick={() => setViewingResult(null)}
            className="mt-4 px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            style={{ fontSize: "14px" }}
          >
            Close
          </button>



        </div>
      )}

      <div
        id="pdf-reportcard-container"
        style={{
          position: "fixed",
          left: "-9999px",
          top: 0,
          width: "800px",
          height: "auto",
          overflow: "hidden",
          zIndex: "-1",
        }}
      ></div>

    </div>

  );

};

export default ExamResultForm;
